import type {ReactElement, ReactNode} from 'react';
import {Text, TextSize} from '@Components/text/text';
import type {SuperUserOptionsGroupProps} from './super-user-options-group.types';
import styles from './super-user-options-group.module.scss';

export function SuperUserOptionsGroup({title, headingAction, children}: SuperUserOptionsGroupProps): ReactElement {
  return (
    <section className={styles.optionsGroup} aria-label={title}>
      <div className={styles.groupHeading}>
        <Text val={title} size={TextSize.SM} bold className={styles.groupTitle} />
        {renderHeadingAction(headingAction)}
      </div>
      <div className={styles.groupItems}>{children}</div>
    </section>
  );
}

function renderHeadingAction(headingAction: ReactNode): ReactElement | null {
  if (!headingAction) {
    return null;
  }

  return <div className={styles.groupHeadingAction}>{headingAction}</div>;
}
